/**
 * How the rating system is named to a reader.
 *
 * TrueRank is 8Ball Padel's, and it stays 8Ball Padel's on a league that brings
 * its own domain. Once the Society is served at thepadelsocietysa.co.za, a
 * visitor there sees no platform chrome at all — by design; the whole point of
 * a league's own address is that the platform is absent from it — so an
 * unattributed "TrueRank" on that page reads as something the Society built.
 *
 * One constant rather than the words typed at each site, because that is the
 * only thing that keeps them the same. The mark was written three different
 * ways across the source before this existed, and a mark spelled three ways is
 * not a mark.
 *
 * ™ rather than ®: ™ asserts an unregistered mark and needs no registration,
 * which is the true claim today. If TrueRank is ever registered with the CIPC
 * this becomes ® — one edit, in one place, which is the other reason it lives
 * here.
 */

/** The mark itself, for every place the name appears. */
export const TRUERANK = 'TrueRank™';

/**
 * Who it belongs to. Said at least once wherever the mark is used.
 *
 * A NON-BREAKING space, and it earns its keep. At 390px the ledger's summary
 * wrapped this to "TRUERANK™ BY 8BALL / PADEL" — a brand name split down the
 * middle, which reads worse than no attribution at all. With the hard space the
 * line breaks after "BY" and the name stays whole.
 */
export const TRUERANK_OWNER = '8Ball\u00A0Padel';

/** The full attribution, for the most prominent use on a surface. */
export const TRUERANK_BY = `${TRUERANK} by ${TRUERANK_OWNER}`;
